// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/SellerForm/PointList/index.less
// module id = 1739
// module chunks = 0